import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { fetchICXPricingData } from "../redux/actions/icxPricing.js";

import {
  MARKET_PLACE,
  HOME,
  GBET_ROUTE,
  LEADERSHIP,
  ACTIVITY_LOG,
  WALLET,
  FAQ_ROUTE,
  PROFILE,
  ERROR_404,
  ILLUSTRATION_GALLERY,
  MIGRATION,
  // CROWN_REDEMPTION,
} from "src/constants/routes";

import Home from "pages/Home.jsx";
import Activity from "pages/Activity.page.jsx";

import GBet from "pages/GBet.jsx";
import Alleyway from "pages/Alleyway.jsx";
import MarketPlace from "pages/MarketPlace.jsx";
import Wallet from "pages/Wallet.jsx";
import FAQ from "pages/FAQ.jsx";
import Layout from "components/layout.tsx";
import Profile from "pages/Profile.jsx";
import Gallery from "pages/IllustrationGallery.jsx";
import Migration from "pages/Migration.jsx";

import {
  detectMarketPlace,
  fetchWalletPath,
  fetchWalletSuccess,
} from "../redux/actions/wallet.js";
import ErrorPage from "components/Error/404Page";
import { WALLET_TYPE } from "src/constants/walletType";
import Maintenance from "components/maintenance/underMaintenance";
import { RootState } from "../types";

const App: React.FC = () => {
  const dispatch = useDispatch();
  const address = useSelector((state: RootState) => state.wallet.walletAddress);
  const { walletType } = useSelector((state: RootState) => state.wallet);

  useEffect(() => {
    dispatch(fetchICXPricingData());
    dispatch(detectMarketPlace(address));
  }, [dispatch, address]);

  useEffect(() => {
    if (address && walletType === WALLET_TYPE.LEDGER) {
      dispatch(fetchWalletSuccess("", ""));
      dispatch(fetchWalletPath("", ""));
    }
  }, [dispatch, address, walletType]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={HOME.INDEX} element={<Home />} />
          <Route path={PROFILE.INDEX} element={<Profile />} />
          <Route path={GBET_ROUTE.INDEX} element={<GBet />} />
          <Route path={ACTIVITY_LOG.INDEX} element={<Activity />} />
          <Route path={ILLUSTRATION_GALLERY.INDEX} element={<Gallery />} />
          <Route path={LEADERSHIP.INDEX} element={<Alleyway />} />
          <Route path={MARKET_PLACE.INDEX} element={<MarketPlace />} />
          <Route path={WALLET.INDEX} element={<Wallet />} />
          <Route path={MIGRATION.INDEX} element={<Migration />} />

          <Route path={FAQ_ROUTE.INDEX} element={<FAQ />} />
          <Route path={ERROR_404.INDEX} element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
          {/* <Route path="*" element={<Maintenance />} /> */}
        </Routes>
      </Layout>
    </Router>
  );
};

export default App; 